import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

import {
	faArrowDown,
	faArrowLeft,
	faArrowUp,
	faCheck,
	faCopy,
	faKey,
	faPencilAlt,
	faPlus,
	faSave,
	faTimes,
	faTrashAlt,
	faUser,
	faUserCheck,
	faUserGroup,
} from '@fortawesome/free-solid-svg-icons';


export class FontAwesomePluginVue {
	static install(app) {
		app.component('font-awesome-icon', FontAwesomeIcon);

		library.add(
			faArrowDown,
			faArrowLeft,
			faArrowUp,
			faCheck,
			faCopy,
			faKey,
			faPencilAlt,
			faPlus,
			faSave,
			faTimes,
			faTrashAlt,
			faUser,
			faUserCheck,
			faUserGroup,
		);
	}
}